import React, { useEffect } from "react"
import { connect } from "react-redux";
import { InfoBoxes } from "../../info-boxes/InfoBoxes";
import { withMainLayout } from "../../view/LayoutHOCs";
import * as layoutService from "../../view/layoutService";
import * as deviceService from "../deviceService";
import DeviceDetailsHeader from "./DeviceDetailsHeader";
import DeviceDetailsDataTableSection from "./DeviceDetailsDataTableSection";
import { DeviceDetailsChartsSection } from "./DeviceDetailsChartsSection";

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Devices",
        redirectTo: "/devices",
    },
    {
        text: "Device Details",
        redirectTo: "/device-details",
    },
]

function DeviceDetailsPage(props) {

    const deviceId = props.match.params.id;

    useEffect(() => {
        layoutService.setPageTitle("Device Details")
        layoutService.setBreadcrumbs(breadcrumbs)
        deviceService.loadById(deviceId)
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])

    return (
        <>
            <InfoBoxes />
            <DeviceDetailsHeader deviceId={deviceId} />
            <DeviceDetailsChartsSection />
            <div className="mt-4">
                <DeviceDetailsDataTableSection deviceId={props.match.params.id} />
            </div>
        </>
    );
}


export default withMainLayout(connect()(DeviceDetailsPage));
